module.exports = __webpack_public_path__ + "img/mail_resend.783d9f7e.png";